import './sass/cardselector.css';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addOrRemoveSelectedBoard } from 'src/redux/slices/boardSlice';

function CardSelector({ boards }) {

  const selectedBoards = useSelector((state) => state.boards.selected_board_ids);
  const all_boards = useSelector((state) => state.boards.available_playing_boards);
  const is_game_restart = useSelector((state) => state.transactionState.is_game_restart);

  const GetBoardItem = () => {
    let boards = [];
    all_boards?.map((x) => {
      
      boards.push(
        <BoardCard
          key={x.id}
          board_id={x.board_id}
          board_name={x.board_name}
          selectedBoards={selectedBoards}
          is_game_restart={is_game_restart}
        />
      );
    });

    return boards;
  };
  return <div className="board-container">{GetBoardItem()}</div>;
}

export default CardSelector;

function BoardCard({ key, board_id, board_name,selectedBoards,is_game_restart }) {

  //const selectedBoards = useSelector((state) => state.boards.selected_board_ids);
  //const [cardSelected, setCardSelected] = useState(isCardSelected);
  const dispatch = useDispatch();

  const handleCardSelected = (id) => {
    //setCardSelected(!cardSelected);
    if (selectedBoards.includes(id) && is_game_restart) {
      alert('You cannot deselect a board in a restarted game. [RESET for clean start.]');
      return;
    }
    dispatch(addOrRemoveSelectedBoard(id));
  };

  return (
    <div key={key} className="card-display" onClick={() => handleCardSelected(board_id)}>
      <div className="card-content">
        <div className={(selectedBoards.includes(board_id)) ? 'card-detail-content card-selected' : 'card-detail-content'}>
          <div className="card-id">{board_id}</div>
          <div className="card-name">{board_name}</div>
        </div>
      </div>
    </div>
  );
}
